{
  "name": "base-material-ui",
  "version": "0.14.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:local": "ng serve --ssl --configuration local",
    "start:dev": "ng serve --ssl --configuration development",
    "build:dev": "ng build --configuration development",
    "build:local": "ng build --configuration local",
    "build:prod": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "^21.2.11",
    "@angular/common": "^21.2.13",
    "@angular/compiler": "^21.2.13",
    "@angular/core": "^21.2.13",
    "@angular/forms": "^21.2.13",
    "@angular/material": "^21.2.11",
    "@angular/platform-browser": "^21.2.13",
    "@angular/router": "^21.2.13",
    "@ngrx/signals": "^21.1.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^21.2.11",
    "@angular/cli": "^21.2.11",
    "@angular/compiler-cli": "^21.2.13",
    "@types/jasmine": "~5.1.0",
    "baseline-browser-mapping": "^2.9.14",
    "jasmine-core": "~5.9.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.9.2"
  }
}
